import { Configuration, FrontendApi } from '@ory/kratos-client';
import kratosAxios, { AxiosError, AxiosResponse } from '@ory/kratos-client/node_modules/axios';
import { API_ENDPOINTS } from 'common/constants/api-endpoints.constants';
import { EAuthFlagName } from 'domains/auth/constants/auth.constants';
import { ROUTES_MAPPING } from 'navigation/constants/route.constants';
import routerTree from 'navigation/routerTree';
import { EAuthLoginFlowId } from '../constants/kratos.constants';
import { getFromLocalstorage, setToLocalstorage } from '../utils/local-storage.utils';

const configuration = new Configuration({
  basePath: API_ENDPOINTS.KRATOS_SELF_SERVICE_BASE_URL,
  baseOptions: {
    withCredentials: true,
  },
});

const kratosAxiosInterceptorsReq = async (config: any): Promise<any> => ({
  ...config,
});

const kratosAxiosInterceptorsReqError = async (error: AxiosError): Promise<never> => Promise.reject(error);

const kratosAxiosInterceptorsRes = async (response: AxiosResponse): Promise<AxiosResponse> => response;

const kratosAxiosInterceptorsResError = async (error: AxiosError): Promise<void> => {
  const isAuth = getFromLocalstorage(EAuthFlagName);

  // Need to find a way how to run guards before loaders run.
  if (isAuth) {
    await routerTree.navigate(ROUTES_MAPPING.PROTECTED.DASHBOARD);
    return Promise.resolve();
  }

  if (error?.response?.status === 401) {
    const searchParams = new URLSearchParams();
    searchParams.append('from', window.location.pathname);

    await routerTree.navigate(`${ROUTES_MAPPING.PUBLIC.LOGIN}?${searchParams.toString()}`);
  }

  if (error?.response?.status === 400) {
    if (error.response.data?.error?.id === EAuthLoginFlowId.SessionAlreadyAvailable) {
      setToLocalstorage(EAuthFlagName, 'true');
      await routerTree.navigate(ROUTES_MAPPING.PROTECTED.DASHBOARD);
    }
  }

  if (error?.response?.status === 422) {
    if (error.response.data?.error?.id === EAuthLoginFlowId.BrowserLocationChangeRequired) {
      return Promise.resolve();
    }
  }

  return Promise.reject(error);
};

kratosAxios.interceptors.request.use(kratosAxiosInterceptorsReq, kratosAxiosInterceptorsReqError);
kratosAxios.interceptors.response.use(kratosAxiosInterceptorsRes, kratosAxiosInterceptorsResError);

export const kratosClient = new FrontendApi(configuration);
